import { Awareness } from 'y-protocols/awareness';
import { DataGlueGraph, DataConnection, NodeInstance, inherentInPortTemplate } from '@glueapp/graph-types';
import { dictionaryFromNumberTuple } from '../helpers/dictionaryFromTuple';
import { createAcceleratedConnectionStructure } from '../helpers/createAcceleratedConnectionStructure';

export function awarenessSelection(awareness: Awareness): number[] {
    const localState = awareness.getLocalState();
    if (!localState || !Array.isArray(localState.selectedLegacyIds)) return [];
    return localState.selectedLegacyIds as number[];
}

export function snapshotNodesInScope(snapshot: DataGlueGraph | undefined, parentFunctionId: string | undefined): NodeInstance[] {
    if (!snapshot) return [];
    if (!parentFunctionId) return snapshot.nodeInstances;
    const fn = snapshot.functions.find(definition => definition.id === parentFunctionId);
    return fn?.nodeInstances ?? [];
}

export function snapshotConnectionsInScope(snapshot: DataGlueGraph | undefined, parentFunctionId: string | undefined): DataConnection[] {
    if (!snapshot) return [];
    if (!parentFunctionId) return snapshot.connections;
    const fn = snapshot.functions.find(definition => definition.id === parentFunctionId);
    return fn?.connections ?? [];
}

export function computeBranchSelection(
    snapshot: DataGlueGraph | undefined,
    parentFunctionId: string | undefined,
    rootId: number,
): number[] {
    const nodes = snapshotNodesInScope(snapshot, parentFunctionId);
    const connections = snapshotConnectionsInScope(snapshot, parentFunctionId);
    const dictionary = dictionaryFromNumberTuple(nodes, node => [node.id, node]);
    const accelerated = createAcceleratedConnectionStructure(connections);
    const root = dictionary[rootId];
    if (!root) return [];

    const collect = (currentNode: NodeInstance): number[] => {
        const receiving = accelerated[currentNode.id];
        if (!receiving) return [currentNode.id];
        return [
            currentNode.id,
            ...[...currentNode.inPorts.map(port => port.name), inherentInPortTemplate.name].flatMap(portName => {
                const portConnection = receiving[portName];
                if (!portConnection) return [];
                const sendingNode = dictionary[portConnection.sendingNodeInstanceId];
                if (!sendingNode) return [];
                return collect(sendingNode);
            }),
        ];
    };

    return Array.from(new Set(collect(root)));
}
